export default function (element, data) {
    const baseUrl = data.baseUrl;
    const filterParam = data.param;
    const applyBtn = element.querySelector('#apply-filter');
    const clearBtn = element.querySelector('#clear-filter');
    const checkboxItems = element.querySelectorAll('.filter-checkbox');

    let filterValues = data.filterValues
        ? String(data.filterValues)
            .split(',')
            .map(v => Number(v))
            .filter(v => !isNaN(v))
        : [];

    applyBtn.addEventListener("click", function () {
        applyFilters();
    });
    clearBtn.addEventListener('click', function() {
        window.location = baseUrl;
    });

    checkboxItems.forEach(item => {
        item.addEventListener('change', function() {
            let itemValue = item.value;

            if (item.checked) {
                if (!filterValues.includes(+itemValue)) {
                    filterValues.push(+itemValue);
                }
            } else {
                filterValues = filterValues.filter((v) => v != +itemValue);
            }
        });
        
    });

    function applyFilters() {
        let sortedValues = [...filterValues].sort((a, b) => a - b);
        let fullUrl = '';
        
        if (sortedValues.length == 0) {
            fullUrl = baseUrl;
        } else {
            let valuesStr = sortedValues.join(",");
            fullUrl = `${baseUrl}/${filterParam}/${valuesStr}`;
        }


        window.location = fullUrl;
    }
};